/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';

function useCountUp(target, duration = 2500, start = false) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!start) return;
    let startTime = null;
    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 4);
      setCount(Math.round(eased * target));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [target, duration, start]);
  return count;
}

function FadeIn({ children, delay = 0 }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setVisible(true); observer.disconnect(); } },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return (
    <div ref={ref} style={{
      opacity: visible ? 1 : 0,
      transform: visible ? 'translateY(0)' : 'translateY(32px)',
      transition: `opacity 1.2s ease ${delay}ms, transform 1.2s ease ${delay}ms`,
    }}>
      {children}
    </div>
  );
}

export default function FoundeursPage({ onNavigate }) {
  const [revenu, setRevenu]           = useState(2000);
  const [heroVisible, setHeroVisible] = useState(false);
  const [showContact, setShowContact] = useState(false);
  const [isMobile, setIsMobile]       = useState(window.innerWidth < 768);

  // Formulaire contact (secondaire)
  const [prenom, setPrenom]   = useState('');
  const [email, setEmail]     = useState('');
  const [ville, setVille]     = useState('');
  const [typeBien, setTypeBien] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);
  const [done, setDone]       = useState(false);

  const types = ['Appartement', 'Maison', 'Villa', 'Chalet', 'Autre'];

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setHeroVisible(true), 400);
    return () => clearTimeout(timer);
  }, []);

  const commission = useCountUp(8,   2000, heroVisible);
  const gainMois   = useCountUp(225, 2800, heroVisible);

  const airbnbNet  = Math.round(revenu * 0.845);
  const havenlyNet = Math.round(revenu * 0.92);
  const gain       = havenlyNet - airbnbNet;

  const handleContact = async () => {
    if (!prenom.trim() || !email.trim() || !ville.trim() || !typeBien) {
      setError('Merci de remplir tous les champs.');
      return;
    }
    if (!email.includes('@')) { setError('Adresse email invalide.'); return; }
    setLoading(true); setError(null);
    try {
      await fetch('/api/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          type: 'lead_fondateur',
          to: 'contact@havenly.fr',
          data: { prenom, email, ville, typeBien, revenu_airbnb: revenu, gain_estime: gain, date: new Date().toLocaleString('fr-FR'), source: 'Page fondateurs' }
        })
      });
      setDone(true);
    } catch (e) {
      setError('Une erreur est survenue. Contactez contact@havenly.fr');
    } finally {
      setLoading(false);
    }
  };

  const inp = { width: '100%', padding: '11px 14px', border: '1px solid var(--border)', borderRadius: 10, fontSize: 14, fontFamily: 'var(--sans)', outline: 'none', color: 'var(--ink)', boxSizing: 'border-box', background: 'var(--white)' };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--surface)', paddingTop: 60 }}>

      {/* Bandeau de bienvenue exclusif */}
      <div style={{
        background: 'linear-gradient(90deg, #0A2A1E 0%, #0F3D2E 100%)',
        borderBottom: '1px solid rgba(29,158,117,0.3)',
        padding: isMobile ? '14px 16px' : '12px 24px',
        textAlign: 'center',
      }}>
        <div style={{ maxWidth: 700, margin: '0 auto' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginBottom: 6, flexWrap: 'wrap' }}>
            <span style={{ fontSize: 14 }}>🎉</span>
            <span style={{ fontSize: isMobile ? 13 : 14, fontWeight: 500, color: '#1D9E75' }}>
              Bienvenue ! Vous accédez à l'offre exclusive hôtes fondateurs.
            </span>
          </div>
          <p style={{ fontSize: isMobile ? 12 : 13, color: 'rgba(255,255,255,0.75)', lineHeight: 1.65, margin: '0 0 4px' }}>
            Airbnb prend <strong style={{ color: '#fff' }}>15,5%</strong> sur chaque réservation · Booking prend <strong style={{ color: '#fff' }}>17%</strong> · Sur Havenly, c'est seulement <strong style={{ color: '#1D9E75' }}>8% à vie</strong> pour les fondateurs.
          </p>
          <p style={{ fontSize: 10, color: 'rgba(255,255,255,0.3)', margin: 0 }}>
            Offre réservée aux hôtes qui accèdent à Havenly via cette page · Taux garanti à vie
          </p>
        </div>
      </div>

      {/* Hero */}
      <div style={{ background: 'linear-gradient(160deg, #0D1B2A 0%, #0F3D2E 100%)', padding: isMobile ? '3rem 1.5rem 2.5rem' : '4rem 2rem 3.5rem', textAlign: 'center', overflow: 'hidden' }}>

        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: 8,
          background: 'rgba(29,158,117,0.15)', border: '1px solid rgba(29,158,117,0.3)',
          borderRadius: 24, padding: '6px 16px', marginBottom: 24,
          opacity: heroVisible ? 1 : 0,
          transform: heroVisible ? 'translateY(0)' : 'translateY(-20px)',
          transition: 'opacity 1s ease 0.2s, transform 1s ease 0.2s',
        }}>
          <div style={{ width: 6, height: 6, borderRadius: '50%', background: '#1D9E75', animation: 'pulse 2s infinite' }} />
          <span style={{ fontSize: 12, color: '#1D9E75', fontWeight: 500 }}>Programme hôtes fondateurs · 23 places restantes</span>
        </div>

        <h1 style={{
          fontFamily: 'var(--serif)', fontSize: isMobile ? 30 : 52,
          lineHeight: 1.15, letterSpacing: '-1px', color: '#fff', marginBottom: 16,
          opacity: heroVisible ? 1 : 0,
          transform: heroVisible ? 'translateY(0)' : 'translateY(24px)',
          transition: 'opacity 1.2s ease 0.4s, transform 1.2s ease 0.4s',
        }}>
          Gardez plus de ce<br/>
          <em style={{ color: '#1D9E75' }}>que vous gagnez.</em>
        </h1>

        <p style={{
          fontSize: isMobile ? 15 : 17, color: 'rgba(255,255,255,0.65)',
          lineHeight: 1.7, maxWidth: 520, margin: '0 auto 32px',
          opacity: heroVisible ? 1 : 0,
          transition: 'opacity 1.2s ease 0.7s',
        }}>
          La plateforme française de location saisonnière. 8% de commission seulement — publiez votre annonce et testez gratuitement.
        </p>

        {/* CTA principal */}
        <div style={{
          opacity: heroVisible ? 1 : 0,
          transform: heroVisible ? 'translateY(0)' : 'translateY(20px)',
          transition: 'opacity 1s ease 0.9s, transform 1s ease 0.9s',
          marginBottom: 40,
        }}>
          <button
            onClick={() => onNavigate('auth', 'register')}
            style={{ display: 'inline-block', background: '#1D9E75', color: '#fff', padding: isMobile ? '14px 28px' : '16px 40px', borderRadius: 32, fontSize: isMobile ? 15 : 17, fontWeight: 500, border: 'none', cursor: 'pointer', fontFamily: 'var(--sans)', boxShadow: '0 4px 24px rgba(29,158,117,0.4)', transition: 'transform 0.2s, box-shadow 0.2s' }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.03)'; e.currentTarget.style.boxShadow = '0 6px 32px rgba(29,158,117,0.5)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = '0 4px 24px rgba(29,158,117,0.4)'; }}>
            Créer mon compte hôte gratuitement →
          </button>
          <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', marginTop: 12 }}>
            Inscription gratuite · Aucune carte bancaire · 8% de commission
          </p>
        </div>

        {/* Stats */}
        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)',
          gap: isMobile ? 8 : 16, maxWidth: 500, margin: '0 auto',
        }}>
          {[
            { display: `${commission}%`, label: 'commission', sub: 'vs 15,5% Airbnb', delay: '0.6s' },
            { display: `+${gainMois}€`,  label: 'par mois',   sub: 'sur 20 nuits à 150€', delay: '0.9s' },
            { display: '24h',            label: 'versement',  sub: 'après check-in', delay: '1.2s' },
          ].map(s => (
            <div key={s.label} style={{
              background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: 14, padding: isMobile ? '12px 8px' : '16px',
              textAlign: 'center',
              opacity: heroVisible ? 1 : 0,
              transform: heroVisible ? 'translateY(0)' : 'translateY(20px)',
              transition: `opacity 1s ease ${s.delay}, transform 1s ease ${s.delay}`,
            }}>
              <div style={{ fontFamily: 'var(--serif)', fontSize: isMobile ? 20 : 28, color: '#1D9E75', letterSpacing: '-1px' }}>{s.display}</div>
              <div style={{ fontSize: isMobile ? 10 : 12, color: 'rgba(255,255,255,0.7)', fontWeight: 500, marginTop: 4 }}>{s.label}</div>
              <div style={{ fontSize: isMobile ? 9 : 11, color: 'rgba(255,255,255,0.35)', marginTop: 3 }}>{s.sub}</div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ maxWidth: 700, margin: '0 auto', padding: isMobile ? '2rem 1rem' : '3rem 2rem', display: 'flex', flexDirection: 'column', gap: 20 }}>

        {/* Calculateur */}
        <FadeIn delay={0}>
          <div style={{ background: 'var(--white)', border: '1px solid var(--border)', borderRadius: 20, padding: isMobile ? '1.5rem' : '2rem' }}>
            <h2 style={{ fontFamily: 'var(--serif)', fontSize: isMobile ? 20 : 22, letterSpacing: '-0.5px', marginBottom: 4 }}>Combien gagnez-vous de plus ?</h2>
            <p style={{ fontSize: 13, color: 'var(--ink-3)', marginBottom: 20, lineHeight: 1.6 }}>Déplacez le curseur pour voir votre gain en temps réel.</p>

            <div style={{ marginBottom: 20 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                <label style={{ fontSize: 13, color: 'var(--ink-3)' }}>Revenu mensuel Airbnb</label>
                <span style={{ fontSize: 16, fontWeight: 500, color: 'var(--ink)' }}>{revenu.toLocaleString('fr-FR')} €</span>
              </div>
              <input type="range" min="500" max="10000" step="100" value={revenu}
                onChange={e => setRevenu(Number(e.target.value))}
                style={{ width: '100%', accentColor: '#1D9E75', cursor: 'pointer' }} />
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: 'var(--ink-4)', marginTop: 4 }}>
                <span>500 €</span><span>10 000 €</span>
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', gap: 10 }}>
              {[
                { label: 'Airbnb (15,5%)', val: `${airbnbNet.toLocaleString('fr-FR')} €`, bg: 'var(--surface)', color: 'var(--ink)', sub: 'après commission' },
                { label: 'Havenly (8%)',   val: `${havenlyNet.toLocaleString('fr-FR')} €`, bg: '#E1F5EE', color: '#0F6E56', sub: 'après commission', border: '1px solid #9FE1CB' },
                { label: 'Vous gagnez',   val: `+${gain.toLocaleString('fr-FR')} €`,      bg: '#0F6E56', color: '#fff', sub: 'par mois', subColor: 'rgba(255,255,255,0.6)' },
              ].map(c => (
                <div key={c.label} style={{ background: c.bg, borderRadius: 12, padding: '14px 16px', border: c.border || 'none', display: isMobile ? 'flex' : 'block', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ fontSize: 12, color: c.color, opacity: isMobile ? 0.7 : 1, marginBottom: isMobile ? 0 : 6 }}>{c.label}</div>
                  <div style={{ fontFamily: 'var(--serif)', fontSize: isMobile ? 18 : 22, color: c.color, transition: 'all 0.3s', fontWeight: c.label === 'Vous gagnez' ? 500 : 400 }}>{c.val}</div>
                  {!isMobile && <div style={{ fontSize: 11, color: c.subColor || c.color, opacity: 0.6, marginTop: 4 }}>{c.sub}</div>}
                </div>
              ))}
            </div>

            {/* CTA dans le calculateur */}
            <button
              onClick={() => onNavigate('auth', 'register')}
              style={{ width: '100%', marginTop: 20, padding: '13px', background: 'var(--green)', color: '#fff', border: 'none', borderRadius: 10, fontSize: 15, fontWeight: 500, cursor: 'pointer', fontFamily: 'var(--sans)', transition: 'transform 0.15s' }}
              onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.01)'}
              onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}>
              Je veux gagner {gain.toLocaleString('fr-FR')} € de plus par mois →
            </button>
          </div>
        </FadeIn>

        {/* Avantages */}
        <FadeIn delay={150}>
          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 12 }}>
            {[
              { icon: '🤖', title: 'Emma IA incluse', desc: 'Répond à vos voyageurs 24h/24 en 4 langues. Automatiquement.' },
              { icon: '💳', title: 'Payé sous 24h', desc: 'Versement automatique 24h après le check-in. Pas de délai.' },
              { icon: '📅', title: 'Sync Airbnb', desc: 'Importez vos disponibilités Airbnb. Aucun risque de double réservation.' },
              { icon: '✅', title: '0€ frais voyageur', desc: 'Le prix affiché est le prix final. Plus de réservations pour vous.' },
            ].map(a => (
              <div key={a.title} style={{ background: 'var(--white)', border: '1px solid var(--border)', borderRadius: 14, padding: '16px 18px', display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                <div style={{ fontSize: 20, flexShrink: 0, marginTop: 2 }}>{a.icon}</div>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 500, color: 'var(--ink)', marginBottom: 4 }}>{a.title}</div>
                  <div style={{ fontSize: 13, color: 'var(--ink-3)', lineHeight: 1.55 }}>{a.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </FadeIn>

        {/* CTA final */}
        <FadeIn delay={300}>
          <div style={{ background: '#0F3D2E', borderRadius: 20, padding: isMobile ? '2rem 1.5rem' : '2.5rem', textAlign: 'center' }}>
            <div style={{ fontSize: 11, color: '#1D9E75', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: 12 }}>23 places fondateurs restantes</div>
            <h2 style={{ fontFamily: 'var(--serif)', fontSize: isMobile ? 24 : 30, color: '#fff', letterSpacing: '-0.5px', marginBottom: 12 }}>
              Prêt à gagner plus<br/>sur chaque réservation ?
            </h2>
            <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.55)', lineHeight: 1.7, marginBottom: 24, maxWidth: 420, margin: '0 auto 24px' }}>
              Publiez votre annonce en 5 minutes. Gardez Airbnb en parallèle. Testez sans risque.
            </p>
            <button
              onClick={() => onNavigate('auth', 'register')}
              style={{ display: 'inline-block', background: '#1D9E75', color: '#fff', padding: isMobile ? '13px 28px' : '15px 40px', borderRadius: 32, fontSize: isMobile ? 15 : 16, fontWeight: 500, border: 'none', cursor: 'pointer', fontFamily: 'var(--sans)', transition: 'transform 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.03)'}
              onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}>
              Créer mon compte hôte →
            </button>
            <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.3)', marginTop: 12 }}>
              Gratuit · Sans carte bancaire · 8% de commission
            </p>
          </div>
        </FadeIn>

        {/* Formulaire contact — secondaire et discret */}
        <FadeIn delay={450}>
          <div style={{ textAlign: 'center', padding: '1rem 0 0' }}>
            {!showContact ? (
              <button onClick={() => setShowContact(true)}
                style={{ fontSize: 13, color: 'var(--ink-4)', background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'var(--sans)', textDecoration: 'underline' }}>
                Vous préférez être contacté par l'équipe ? Cliquez ici
              </button>
            ) : done ? (
              <div style={{ background: 'var(--white)', border: '1px solid var(--border)', borderRadius: 16, padding: '1.5rem', textAlign: 'center' }}>
                <div style={{ fontSize: 28, marginBottom: 8 }}>✅</div>
                <p style={{ fontSize: 14, color: 'var(--ink-3)' }}>Merci {prenom} ! Vous serez contacté(e) très prochainement.</p>
              </div>
            ) : (
              <div style={{ background: 'var(--white)', border: '1px solid var(--border)', borderRadius: 16, padding: isMobile ? '1.5rem' : '2rem', textAlign: 'left' }}>
                <h3 style={{ fontFamily: 'var(--serif)', fontSize: 18, marginBottom: 4 }}>Être contacté par l'équipe</h3>
                <p style={{ fontSize: 13, color: 'var(--ink-3)', marginBottom: 16 }}>Matthieu vous répondra personnellement sous 24h.</p>
                {error && <div style={{ background: '#FCEBEB', border: '1px solid #F09595', borderRadius: 8, padding: '8px 12px', marginBottom: 12, fontSize: 13, color: '#A32D2D' }}>{error}</div>}
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 10 }}>
                    <div>
                      <label style={{ fontSize: 12, fontWeight: 500, color: 'var(--ink-3)', display: 'block', marginBottom: 4 }}>Prénom</label>
                      <input type="text" placeholder="Marie" value={prenom} onChange={e => setPrenom(e.target.value)} style={inp} onFocus={e => e.target.style.borderColor = 'var(--green)'} onBlur={e => e.target.style.borderColor = 'var(--border)'} />
                    </div>
                    <div>
                      <label style={{ fontSize: 12, fontWeight: 500, color: 'var(--ink-3)', display: 'block', marginBottom: 4 }}>Ville</label>
                      <input type="text" placeholder="Nice, Paris..." value={ville} onChange={e => setVille(e.target.value)} style={inp} onFocus={e => e.target.style.borderColor = 'var(--green)'} onBlur={e => e.target.style.borderColor = 'var(--border)'} />
                    </div>
                  </div>
                  <div>
                    <label style={{ fontSize: 12, fontWeight: 500, color: 'var(--ink-3)', display: 'block', marginBottom: 4 }}>Email</label>
                    <input type="email" placeholder="marie@exemple.fr" value={email} onChange={e => setEmail(e.target.value)} style={inp} onFocus={e => e.target.style.borderColor = 'var(--green)'} onBlur={e => e.target.style.borderColor = 'var(--border)'} />
                  </div>
                  <div>
                    <label style={{ fontSize: 12, fontWeight: 500, color: 'var(--ink-3)', display: 'block', marginBottom: 6 }}>Type de bien</label>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                      {types.map(t => (
                        <button key={t} onClick={() => setTypeBien(t)}
                          style={{ padding: '6px 14px', border: `1px solid ${typeBien === t ? 'var(--green)' : 'var(--border)'}`, borderRadius: 20, fontSize: 13, fontFamily: 'var(--sans)', cursor: 'pointer', background: typeBien === t ? '#E1F5EE' : 'var(--white)', color: typeBien === t ? '#0F6E56' : 'var(--ink-3)' }}>
                          {t}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
                <button onClick={handleContact} disabled={loading}
                  style={{ width: '100%', marginTop: 16, padding: '12px', background: loading ? '#9FE1CB' : 'var(--green)', color: '#fff', border: 'none', borderRadius: 10, fontSize: 14, fontWeight: 500, cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'var(--sans)' }}>
                  {loading ? 'Envoi...' : 'Envoyer ma demande →'}
                </button>
              </div>
            )}
          </div>
        </FadeIn>

      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.4; transform: scale(0.8); }
        }
      `}</style>

    </div>
  );
} 